import gql from "graphql-tag";
const createCalcMutation = gql(`
mutation createCalc($params: CalcInput!) {
  createCalc(params: $params) {
  id
  sub
  calculator
  status
  exitcode
  }
}
`)
export default createCalcMutation;